
export default {
  "m":{
    "sms_login":"短信登錄",
    "get_vercode":"獲取驗證碼",
    "change_mobile":"更換手機號",
    "log_reg_agree":"登錄/註冊代表同意{msg_ss}",
    "old_mobile":"原手機號",
    "new_mobile":"新手機號",
    "agency_reginfo_fill":"公會註冊信息填寫",
    "audit_res":"審核結果",
    "agency_name":"公會名稱",
    "agency_name_input":"請輸入公會名稱",
    "agency_name_input_note":"注：公會名稱建議簡短易記，不超過30字",
    "agency_logo":"公會LOGO",
    "agency_logo_unpload_note":"請上傳清晰的公會LOGO，支持PNG/JPG/JPEG格式",
    "agency_contact_name":"公會聯繫人",
    "user_contact_name":"請填寫用戶平台日常聯繫的人員名稱",
    "agency_contact_phone":"公會聯繫電話",
    "agency_whatsapp":"公會長WhatsApp",
    "agency_whatsapp_contact":"請輸入公會長的WhatsApp聯繫方式",
    "agency_use_lang":"公會長使用語言",
    "agency_head_ID":"公會長ID",
    "agency_ID_input":"請輸入公會長BuzzCast APP的用戶ID，用於後期資金發放",
    "reg_country":"註冊國家",
    "inhand_ID_photo":"手持證件照片",
    "upload_note_t":"上傳注意事項",
    "agency_self_inhand_ID":"必須公會長本人手持護照證件進行拍照",
    "photo_must_clearly":"正面需清晰拍出人物及真實的護照信息",
    "mian_form_country":"主播主要來源國家",
    "invite_code":"邀請碼",
    "your_profile_submit_success":"您的資料提交成功！我們會盡快處理。<br>審核結果會發送到公會長的BuzzCastAPP通知中，請注意查看！",
    "your_profile_approved":"您提交的資料審核未通過！拒絕理由“手持證件照不清晰”。<br>請重新填寫或在BuzzCastAPP上聯繫官方小助手進行諮詢。<br>",
    "return_refill":"返回重新填寫",
    "success_agency":"恭喜您成功入駐平台，【點我】開始工作吧！",
    "personal_account":"個人賬號",
    "my_agency":"我的公會",
    "your_agency_been_forcibly":"您的公會已被平台強制終止合作，您將無法再登錄系統。 如有疑問請聯繫BuzzCastAPP官方小助手或專屬運營。",
    "invite_live_join":"邀請主播加入公會鏈接",
    "base_info":"基本信息",
    "apply_time":"申請時間",
    "join_time":"入駐時間",
    "cooper_status":"合作狀態",
    "streamer_manage":"主播管理",
    "sereamer_apply":"主播審批",
    "sereamer_nickname":"主播暱稱",
    "remark":"備註",
    "no_remark":"無備註",
    "add_remark":"添加備註",
    "birth":"出生年月",
    "user_status":"用戶狀態",
    "temporarily_frozen":"臨時凍結",
    "permanently_frozen":"永久凍結",
    "fans_num":"粉絲數量",
    "sign_status":"簽約狀態",
    "sign_ing":"簽約中",
    "sign_time":"簽約時間",
    "release_time":"解約時間",
    "live_viola_record":"直播違規記錄",
    "sign_record":"簽約記錄",
    "current_contract_status":"當前簽約狀態",
    "termination_reason":"解約原因",
    "violation_reason":"違規原因",
    "violation_time":"違規時間",
    "processing_result":"處理結果",
    "exported_data":"導出數據",
    "join_agency_apply":"入會審批",
    "audit_status":"審核狀態",
    "pending_review":"待審核",
    "pending_HQ_review":"等待總部審核",
    "not_approved_HQ":"總部審核未通過",
    "withdrawn":"已撤銷",
    "audit_trail":"審核記錄",
    "oper":"操作",
    "other_video_materials":"其他視頻材料",
    "pass":"通過",
    "pass_streamer_join_agency_apply":"通過主播入會申請",
    "reject_streamer_join_agency_apply":"拒絕主播入會申請",
    "agree_streamer_join_agency":"同意主播{msg_ss1}成為{msg_ss2}旗下的主播~",
    "reject_streamer_join_agency":"拒絕成員{msg_ss1}成為{msg_ss2}的成員的申請！",
    "img_material":"圖片材料",
    "approver":"審批人",
    'user_enter_bind_phone':'請輸入手機號碼',
    'vericode':'驗證碼',
    'input_vericode':'輸入驗證碼',
    'login':'登錄',
    'reg':'註冊',
    'logout':'退出',
    'search_for':'搜索',
    'subscription_closed':'已解約',
    'agency_ID':'公會編碼: {msg_ss}',
    'reset':'重置',
    'live_ID':'主播ID',
    'live_record':'直播錄屏',
    'email':'郵箱',
    'phone':'手機號碼',
    'mastery_lang':'掌握語言',
    'to':'至',
    'cancel':'取消',
    'Confirm':'確定',
    'preview':'預覽',
    'rejected':'已拒絕',
    'tip':'提示',
    'i_got_it':'我知道了',
    'cancelled':'已註銷',
    'refused':'拒絕',
    'agency_agree':'公會已同意',
    'platform_agree':'平台已同意',
    'user_not_exist':'該用戶不存在',
    'user_frozen':'該用戶已被凍結',
    'reviewing':'審核中',
    'review_pass':'審核通過',
    'review_failed':'審核未通過',
    'xx_hours':'{msg_ss} 小時',
    'xx_days':'{msg_ss} 天',
    'xx_hour':'{msg_ss} 小時',
    'xx_day':'{msg_ss} 天',
    'xx_year':'{msg_ss} 年',
    'xx_years':'{msg_ss} 年',
    'check_phone_istrue':'請檢查手機號是否輸入正確',
    'male':'男',
    'female':'女',
    'avatar':'頭像',
    'normal':'正常',
    'live_room':'直播間',
    'view':'查看',
    'oper_success':'操作成功',
    'copy_success':'複製成功',
    'new_mobile_already_reg':'新手機號碼已註冊',
    'general_user':'普通用戶',

    'copy':'複製',
    'gender':'性別',
    'submit':'提交',
    'permanent':'永久',
    'agree_agreement':'同意並遵守簽約協議',
    'vericode_error':'驗證碼有誤',
    'resend':'重新發送',
    'approved':'已通過',
    'not_approved':'未通過',
    'agency_rejected':'平台已拒絕',
    'select':'選擇',
    'search':'搜索',
    'rejection_reason':'拒絕理由',
    'no_data':'數據為空',
    'oper_failed':'操作失敗',
    'leave_agency_apply':'退會審批',
    'over_word_limit':'已超出字數限制',
    'delete':'刪除',
    'nickname':'暱稱',
    'file_is_too_large':'文件過大',

    'community_convention':'Buzzcast社區公約',
    'approval_time':'審批時間',
    'guild_system_title':'BuzzCast社交平臺公會繫統',
    'return':'返回',
    'img_upload_fail':'圖片上傳失敗',
    'cooper_ing':'合作中',
    'upload_file_format_incorrect':'上傳的文件格式不正確',
    'token_invalid':'Token失效，請重新登錄！',
    'network_busy':'網絡繁忙，請重試',
    'minute':'{msg_ss}分鐘',

    'live_room_ID':'直播間ID',
    'scan_code':'BuzzCast APP掃碼登錄',
    'open_code':'打開BuzzCastApp，點擊我的二維碼掃一掃',
    'refresh':'刷新',
    'login_confirm':'登錄確認',
    'account':'賬號信息',
    'user_name':'用戶名',
    'edit':'修改',
    'changing':'換綁',
    'mobile_number':'手機賬號',
    'mobile_login':'可以使用手機號碼{msg_ss}進行登錄',
    'appId_login':'可以使用AppID為【{msg_ss}】的賬號掃一掃登錄',
    'code_login':'未綁定BuzzCastAppID，綁定後可使用二維碼掃碼登錄',
    'verification_log':'未綁定手機號，綁定後可使用手機號和驗證碼登錄',
    'binding_success':'绑定成功',
    'binding_mobile':'綁定手機號',
    'edit_name':'修改用戶名',
    'binding_alert':'換綁提示',
    'new_appId':'直接使用新的APPID掃碼綁定，原APPID會被直接替換',
    'binding_account':'綁定BuzzCastApp賬號',
    'anchor_earings':'主播收益',
    'signing_date':'簽約日期',
    'statistical_date':'統計日期',
    'valid_min':'總有效時長(分鐘)',
    'valid_day':'有效天(天數)',
    'total_revenue':'總收益',

    'bind':'綁定',
    'please_agree_agree':'請同意協議',
    'note':'說明：本系統所顯示的時間均為美國紐約時間(EST)',
    'app_phone':'註冊APP的手機號',
    'host_num':'主播數量',
    'enter_host_num':'請輸入旗下所有主播數量',
    'platform':'合作平台',
    'statement':'月流水',
    'enter_income':'請輸入平均每月的收益',
    'check_commas':'格式不正確。請檢查多平台之間是否以英文逗號隔開',
    'submit_success':'您的資料提交成功！我們會盡快處理',
    'usd':'美金',
    'many_platforms':'請輸入之前合作過的直播平台，最多20平台',
    'limit_platform': '最多20平台',
    'user_has_delete':'該用戶已註銷',
    'cant_commit':'您已經是簽約主播，無法同時申請公會入駐',
    'cant_commit_1':'您已申請簽約主播中，無法同時申請公會入駐',
    'passwd': '密碼',
    'passwd_placeholder': '密碼支持6到20位 ',
    'live_rights': '免時長考核',
    'edit_log': '修改記錄',
    'edit_time': '修改時間',
    'edit_pwd': '修改密码',
    'old_pwd': '原密碼',
    'new_pwd': '新密碼',
    'confirm_pwd': '確認密碼',
    'forget_pwd': '忘記密碼？',
    'email_check': '郵箱格式不正確',
    'phone_pwd_error': '手機號或密碼有誤',
    'ten_min_error': '請10分鐘後再試',
    'phone_bind_error': '手機號碼已被綁定其他賬號，請更換新的手機號進行綁定。',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': '公會長ID已有人填寫，請重新填寫',
    'pwd_error': '密碼錯誤',
    'phone_not_reg_error': '賬號未註冊',
    'pwd_nq': '兩次輸入的新密碼不一致',
    'sign_anchor_error': '您已經是簽約主播，無法同時申請公會入駐',
    'apply_anchor_error': '您已申請簽約主播中，無法同時申請公會入駐',
    'have-expired':'已過期',
    'approval-time':'審批時間',
    'reasons-for-refusal':'請輸入拒絕理由',
    'Transfer-grounds':'轉會理由',
    'code_expire': '驗證碼過期，請點擊驗證碼重新刷新',
    'transfer-approval':' 轉會審批',
    'live_state_placeholder': '開播狀態',
    'live_state_open': '正常',
    'live_state_temporary_banned': '禁播',
    'live_state_forever_banned': '永久禁播',
    'live_allowed_time': '允許開播時間',
    'live_banned_time': '允許開播時間',
    'deduct_money': '扣B幣金額',
    'final_income': '實際收益',
    'select_start_dt': '請選擇開始時間',
    'select_end_dt': '請選擇結束時間',
    'less_then_end_dt': '開始時間必須小於等於結束時間',
    'System_automatically_through':'系統自動通過',
    'btrade_err': '該公會長ID不可用',

    'mouth_anchor': '薪資主播',
    'day_anchor': '日薪主播',
    'guild_anchor': '公會長獎勵(日薪)',
    'mouth_anchor_st': '月薪開始時間',
    'mouth_anchor_et': '月薪結束時間',
    'day_anchor_st': '日薪開始時間',
    'day_anchor_et': '日薪結束時間',
    'all_award_bcoin': '日薪獎勵總收益',
    'live_hour': '直播有效時長獎勵',
    'salary_day': '日期',
    'day_in_come': '公會當天收益(B幣)',
    'award_ration_flag_str': '獎勵比例',
    'payable_money': '公會長B幣獎勵',
    'host_bcoins': '主播收益B幣',
    'total_official': '官方獎勵B幣總數',
    'actual_bcoins_awarded': '實際獎勵B幣',
    "change_bound_account":"更換綁定帳號" ,
    "agent_id_form":"公會長ID:" ,
    "BuzzCast_verification_code":"BuzzCast驗證碼:" ,
    "send_success":"發送成功" ,
    "account_changed_successfully":"綁定帳號更換成功。" ,
    "invite_guild_url":"邀請成為BuzzCast公會長鏈接:{msg_ss}" ,
    "invite_guild_code":"我的邀請碼:{msg_ss}" ,
    "save":"保存" ,
    "compile":"編輯" ,
    "agent_nvitation_eward":"公會長邀請獎勵" ,
    "agent_name":"公會長暱稱" ,
    "guild_id":"公會編碼" ,
    "guild_income_30days":"近30天公會收益" ,
    "guild_invite_income_30days":"近30天邀請公會收益" ,
    "agency_commission_ratio":"代理佣金比例" ,
    "invite_income_bcoins":"邀請獎勵B币" ,
    "id_not_exist": "該 ID 不存在",
    'reward_distribution_status': '獎勵發放狀態',
    'must_number': '您輸入的內容必須是純數字格式。',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh_rhk.js